module.exports = __webpack_public_path__ + "img/gift-content-in.c6f17462.png";